import React, { FC } from "react"
import styled from "styled-components"
import { H3 } from "@carrotfertility/carotene"
import { SinglePathSVG } from "components/views/SVG"
// @ts-ignore
import colors from "css/variables/_colors.scss"
import CarrotMarkdown from "../../../utils/CarrotMarkdown"
import { getStyleOverridesClone } from "../../dynamic-content/DynamicContentMarkdown"

type TileProps = {
  title: string
  description?: string
  secondaryDescription?: string
  iconUrl?: string
  onClick: () => void
}

const TileContainer = styled.div`
  border: 2px solid #cccccc;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 16px 16px 24px;
  cursor: pointer;
`

const DisabledTileContainer = styled(TileContainer)`
  background-color: ${colors.lightGray};
  cursor: default;
`
const TileIcon = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
`
const TTCDescriptionOverrides = getStyleOverridesClone()
TTCDescriptionOverrides.p = styled.p.attrs({ className: "black-60" })`
  font-size: 14px;
  line-height: 150%;
  font-family: "Gotham A", "Gotham B", sans-serif;
  margin-top: 4px;
`
const TTCSecondaryDescriptionOverrides = getStyleOverridesClone()
TTCSecondaryDescriptionOverrides.p = styled.p.attrs({ className: "black-40" })`
  margin-top: 21px;
  font-size: 14px;
  line-height: 150%;
  font-family: "Gotham A", "Gotham B", sans-serif;
  font-style: italic;
`

const RightArrow = styled(SinglePathSVG).attrs({ className: "carrot-orange" })`
  width: 10px;
  height: 10px;
  margin-top: 6px;
  position: relative;
  left: calc(100% - 10px);
`

const Tile: FC<TileProps> = ({ title, description, secondaryDescription, iconUrl, onClick }) => {
  return (
    <TileContainer onClick={onClick}>
      {iconUrl && <TileIcon src={iconUrl} />}
      <H3>{title}</H3>
      {description && <CarrotMarkdown source={description} styleOverrides={TTCDescriptionOverrides} />}
      {secondaryDescription && (
        <CarrotMarkdown source={secondaryDescription} styleOverrides={TTCSecondaryDescriptionOverrides} />
      )}
      <RightArrow icon="rightArrow" />
    </TileContainer>
  )
}

type DisabledTileProps = {
  title: string
  description?: string
  secondaryDescription?: string
  iconUrl?: string
}
export const DisabledTile: FC<DisabledTileProps> = ({ title, description, secondaryDescription, iconUrl }) => {
  return (
    <DisabledTileContainer>
      {iconUrl && <TileIcon src={iconUrl} />}
      <H3>{title}</H3>
      {description && <CarrotMarkdown source={description} styleOverrides={TTCDescriptionOverrides} />}
      {secondaryDescription && (
        <CarrotMarkdown source={secondaryDescription} styleOverrides={TTCSecondaryDescriptionOverrides} />
      )}
    </DisabledTileContainer>
  )
}

export default Tile
